// To be triggered when a user adds an item to their cart.
export const addToCartEvent = 'AddToCartCustom';

// To be triggered when a user clicks "Get started" on the /start landing page.
export const clickGetStartedEvent = 'GetStarted';

// To be triggered when a user clicks "Personalize" on an item view / template page.
export const clickPersonalizeEvent = 'Personalize';

// To be triggered when a user makes their first purchase.
export const firstPurchaseEvent = 'FirstPurchase';

// To be triggered when a user creates an account.
export const newAccountEvent = 'NewAccount';

// To be triggered when a user purchases a premiere subscription.
export const premiereSignupEvent = 'PremiereSignup';

// To be triggered when a user makes a purchase.
export const purchaseEvent = 'PurchaseCustom';
